<template>
  <div
    class="grid-of-products"
    :class="{
      'grid-of-products--full-images': block.renderAs === 'full-images',
    }"
    :style="{
      '--number-of-lines': numberOfLines.mobile,
      '--number-of-lines-desktop': numberOfLines.desktop,
    }"
  >
    <component
      :is="cardComponent(link)"
      v-for="(link, index) in links"
      :key="link._key"
      v-bind="cardAttributes(link, index)"
    />
  </div>
</template>

<script>
import ListGallery from '../mixins/ListGallery'

import CtaImage from '@/blocks/CtaImage'
import CtaVideo from '@/blocks/CtaVideo'
import ProductCardV2 from '@/components/Product/Card.v2'
import ImageWithProducts from '@/components/Image/ImageWithProducts'

import { instianciateProduct } from '@/entities/sanity/product'

import { DISPLAY_OPTION } from '@/const'
import {
  getProductCardImageListDesktop,
  getProductCardImageListMobile,
} from '@/utils/image'

export default {
  name: 'LineOfLinks',
  mixins: [ListGallery],
  props: {
    links: {
      type: Array,
      required: true,
    },
    block: {
      type: Object,
      required: true,
    },
    isFirst: {
      type: Boolean,
      default: false,
    },
    isHome: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    gridOfItems: [],
  }),
  created() {
    this.gridOfItems = this.links
  },
  methods: {
    cardComponent(link) {
      if (['linkToProduct', 'linkToProductColor'].includes(link._type)) {
        if (link.product_card_display === 'banner_with_arrow') {
          return ImageWithProducts
        }
        return ProductCardV2
      }

      if (link._type === 'linkToContent') {
        if (link.display_options === DISPLAY_OPTION.VIDEO) {
          return CtaVideo
        }

        return CtaImage
      }

      return 'div'
    },
    cardAttributes(link, i) {
      if (['linkToProduct', 'linkToProductColor'].includes(link._type)) {
        if (link.product_card_display === 'banner_with_arrow') {
          const image =
            link.display_options === DISPLAY_OPTION.OVERRIDE_IMAGE &&
            link.image !== null
              ? link.image
              : link.product.image?.image ?? null

          return {
            video:
              link.display_options === DISPLAY_OPTION.VIDEO &&
              link.video !== null
                ? link.video
                : null,
            imageDesktop:
              this.gridItemPositions[i] && image
                ? getProductCardImageListDesktop(
                    image,
                    this.gridItemPositions[i].desktop.type,
                    this.block.renderAs,
                    this.isFirst
                  )
                : null,
            imageMobile: this.gridItemPositions[i]
              ? getProductCardImageListMobile(
                  image,
                  this.block.renderAs,
                  this.isFirst
                )
              : null,
            products: [link.product],
            productsPosition: link.product_card_position,
            targetColor:
              link._type === 'linkToProductColor' ? link.color : null,
            hideProductPrices: link.hide_prices,
            productRender:
              link._type === 'linkToProductColor'
                ? link.banner_render
                : undefined,
            style: this.gridItemPositions[i]
              ? `
              --product-grid-column-mobile: ${this.gridItemPositions[i].mobile.column};
              --product-grid-column-desktop: ${this.gridItemPositions[i].desktop.column};
              --product-grid-row-mobile: ${this.gridItemPositions[i].mobile.row};
              --product-grid-row-desktop: ${this.gridItemPositions[i].desktop.row};
          `
              : '',
          }
        }

        return {
          productDocument: instianciateProduct(link.product),
          typeMobile: this.gridItemPositions[i]
            ? this.gridItemPositions[i].mobile.type
            : '',
          typeDesktop: this.gridItemPositions[i]
            ? this.gridItemPositions[i].desktop.type
            : '',
          style: this.gridItemPositions[i]
            ? `
          --product-grid-column-mobile: ${this.gridItemPositions[i].mobile.column};
          --product-grid-column-desktop: ${this.gridItemPositions[i].desktop.column};
          --product-grid-row-mobile: ${this.gridItemPositions[i].mobile.row};
          --product-grid-row-desktop: ${this.gridItemPositions[i].desktop.row};
          `
            : '',
          small: ['1/7', '7/13'].includes(
            this.gridItemPositions[i].mobile.column
          ),
          isFirst: this.isFirst && this.links.length === 1,
          preloadImage: this.isFirst,
          isHome: this.isHome,
          targetColor: link._type === 'linkToProductColor' ? link.color : null,
          overrideImage:
            link.display_options === DISPLAY_OPTION.OVERRIDE_IMAGE &&
            link.image !== null
              ? link.image
              : null,
          video:
            link.display_options === DISPLAY_OPTION.VIDEO && link.video !== null
              ? link.video
              : null,
          videoMobile:
            link.display_options === DISPLAY_OPTION.VIDEO &&
            link.video_mobile !== null
              ? link.video_mobile
              : null,
        }
      }

      if (link._type === 'linkToContent') {
        const image =
          link.display_options === DISPLAY_OPTION.VIDEO
            ? undefined
            : link.display_options === DISPLAY_OPTION.OVERRIDE_IMAGE &&
              link.image !== null
            ? link.image
            : link.link?.internalLink?.image ?? null

        return {
          block: {
            title: link.title ?? link.content.title,
            accroche: link.hook,
            image: {
              image,
            },
            text_color: link.text_color,
            text_position: link.text_position,
            btn_hidden: link.btn_hidden,
            btn_label: link.btn_label,
            countdown_date: link.countdown_date,
            link: link.link,
            is_full: true,
            has_sibbling: this.links.length > 1,
            video:
              link.display_options === DISPLAY_OPTION.VIDEO &&
              link.video !== null
                ? link.video
                : null,
            videoMobile:
              link.display_options === DISPLAY_OPTION.VIDEO &&
              link.video_mobile !== null
                ? link.video_mobile
                : null,
          },
          style: this.gridItemPositions[i]
            ? `
          --product-grid-column-mobile: ${this.gridItemPositions[i].mobile.column};
          --product-grid-column-desktop: ${this.gridItemPositions[i].desktop.column};
          --product-grid-row-mobile: ${this.gridItemPositions[i].mobile.row};
          --product-grid-row-desktop: ${this.gridItemPositions[i].desktop.row};
          `
            : '',
        }
      }

      return {}
    },
  },
}
</script>
